import { useEffect } from 'react';
import ErrorCard from 'components/ErrorCard/ErrorCard';
import {
  CheckoutFieldErrorStates,
  useConsolidatedCheckout,
} from 'lib/context/ConsolidatedCheckoutContext/ConsolidatedCheckoutContext';
import styles from './CheckoutPageAlerts.module.scss';

/* CheckoutPageAlert */
export default function CheckoutPageAlerts() {
  const { checkoutFieldErrorStates, submissionErrorsAreVisible } =
    useConsolidatedCheckout();

  const errorStates = Object.values(checkoutFieldErrorStates);
  const errorCount = errorStates.filter(Boolean).length;
  const hasErrors = errorCount > 0;
  const hasMultipleErrors = errorCount > 1;

  useEffect(() => {
    if (hasErrors && submissionErrorsAreVisible) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [hasErrors, submissionErrorsAreVisible]);

  if (!hasErrors || !submissionErrorsAreVisible) {
    return null;
  }

  const errorMessage = getErrorMessage(
    checkoutFieldErrorStates,
    hasMultipleErrors
  );

  return errorMessage ? (
    <div className={styles.checkoutPageAlert}>
      <ErrorCard message={errorMessage} />
    </div>
  ) : null;
}

function getErrorMessage(
  checkoutFieldErrorStates: CheckoutFieldErrorStates,
  hasMultipleErrors: boolean
) {
  if (hasMultipleErrors) {
    return 'Please fix the errors below before continuing.';
  }

  if (checkoutFieldErrorStates.hasPaymentPolicyError) {
    return 'Please agree to the payment policy before continuing.';
  }

  if (checkoutFieldErrorStates.hasESignatureError) {
    return 'Please sign the e-signature before continuing.';
  }

  if (checkoutFieldErrorStates.hasPaymentMethodError) {
    return 'Please select a payment method before continuing.';
  }

  if (checkoutFieldErrorStates.hasSubmissionError) {
    return 'There was an error processing this request. Please try again in a few seconds.';
  }

  return null;
}
/* */
